import type { JSX } from 'react';
import { IconButton, Icon } from '@wistia/vhs';
import { DownloadModal } from '~/singlePageApp/components/DownloadModal';

export type DownloadMediaButtonProps = {
  mediaHashedId: string;
};

export const DownloadMediaButton = ({ mediaHashedId }: DownloadMediaButtonProps): JSX.Element => {
  return (
    <DownloadModal
      key="download"
      mediaHashedId={mediaHashedId}
      isAnonymousViewer={true}
      toggle={(openModal) => (
        <IconButton
          icon={
            <Icon
              type="download"
              size="md"
            />
          }
          preventTooltip={true}
          onClick={openModal}
          size="md"
        />
      )}
    />
  );
};
